import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { ROUTE_PORTFOLIO } from '@/constants/routes';

import { Table } from '../components/Table';
import { WithDummyData } from '../components/WithDummyData';

import { useUpdateTransactionPortfolio } from '../hooks';
import type { TransactionInput } from '../hooks';

import { Row } from '../components/Table/constants';

import { isTransaction } from '../utils';

interface Props {
  portfolioId: string;
}

export const PopulatedState = ({ portfolioId }: Props) => {
  const dispatch = useDispatch();

  const { mutate } = useUpdateTransactionPortfolio({
    onSuccess: ({ updateTransactionPortfolio }) => {
      const { id } = updateTransactionPortfolio;
      dispatch({
        type: ROUTE_PORTFOLIO,
        payload: { portfolioId: id },
      });
    },
  });

  const handleSave = useCallback(
    (rows: Row[]) => {
      if (rows.length === 0) return;

      const transactions: TransactionInput[] = [];

      for (const row of rows) {
        const transaction = {
          symbol: row.ticker.symbol,
          exchangeCode: row.ticker.exchangeCode,
          date: row.date?.toISOString().split('T')[0],
          units: row.shares,
          value: row.price,
          totalValue: row.cost,
          type: row.type?.toUpperCase(),
        };

        if (isTransaction(transaction)) {
          transactions.push(transaction);
        }
      }

      if (transactions.length === 0) return;

      mutate({ id: portfolioId, transactions });
    },
    [mutate, portfolioId]
  );

  return (
    <WithDummyData rowCount={10001}>
      {({ data }) => <Table data={data} onSave={handleSave} />}
    </WithDummyData>
  );
};
